<!--
 * @Author: weijinpeng
 * @LastEditors: weijinpeng
 * @Date: 2024-03-01 14:10:38
 * @LastEditTime: 2024-06-07 15:13:01
 * @Description: 
-->
<template>
    <div class="elist">
        <div 
            class="line" 
            v-for="(item,index) in lineNum" 
            :key="index" 
            >
            <!-- 左侧分割线 -->
            <div class="leftLine"></div>
            <!-- 线段 -->
            <div class="line_list" :style="{ height: lineHeight,borderRadius:lineRadius }">
                <!-- <div class="topTxt" v-if="num <= item.max && num >= item.min">{{ num + ' 吨' }}</div>
                <div class="topTxt" v-if="num >= item.min && !item.max">{{ num + ' 吨' }}</div> -->
                <div class="banner" v-if="num <= item.max && num >= item.min" :id="name" :style="{ height: lineHeight,borderRadius:lineRadius }"></div>
                <div class="banner" v-if="num >= item.min && !item.max" :id="name" :style="{ height: lineHeight,borderRadius:lineRadius }"></div>
                <div class="btmTxt">{{ item.txt }}</div>
            </div>
            <!-- 右侧图片 -->
            <div class="logo" v-if="(num <= item.max && num >= item.min) || (num >= item.min && !item.max)">
                <img :src="'/api/fileSystem/file/download?fileId='+imgId" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'eList',
    props:{
        // 元素id
        name:{
            type:String,
            default:() => null
        },
        // 循环线段
        lineNum:{
            type:Array,
            default:() => []
        },
        // 线段高度
        lineHeight:{
            type:String,
            default:() => '10px'
        },
        // 线段圆角
        lineRadius:{
            type:String,
            default:() => '10px'
        },
        // 图片id
        imgId:{
            type:String,
            default:() => null
        },
        // 排放数据
        num:{
            type:Number,
            default:() => 0
        },
    },
    setup(props) {
        const data = reactive({
            // 元素id
            name:props.name,
            // 循环线段
            lineNum:props.lineNum,
            // 线段高度
            lineHeight:props.lineHeight,
            // 线段圆角
            lineRadius:props.lineRadius,
            // 图片id
            imgId:props.imgId,
            // 排放数据
            num:props.num,
        })
        const changeWidth = () => {
            const num = data.num;
            const list = data.lineNum;
            const progess = document.getElementById(data.name)
            let wid = 0;
            for(let i = 0 ; i < list.length ; i++){
                if(list[i].max){
                    if(num >= list[i].min && num <= list[i].max){
                        wid = num / list[i].max * 100
                        break
                    }
                }else{
                    wid = 100
                }
                
            }
            wid = wid < 1 ? 1 : wid > 100 ? 100 : wid
            progess.style.width = wid + '%'
        }
        onBeforeMount(() => {
            
        })
        onMounted(() => {
            changeWidth()
        })
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.elist{
    width: 100%;
    border-left: 1px solid rgba(0,0,0,0.45);
    border-bottom: 1px solid rgba(0,0,0,0.45);
    padding: 15px 0;
    .line{
        width: 100%;
        display: flex;
        align-items: center;
        height: 65px;
        .leftLine{
            width: 20px;
            height: 1px;
            background: rgba(0,0,0,0.15);
        }
        .line_list{
            width: 400px;
            background: #D7E1F2;
            margin-right: 15px;
            position: relative;
            .topTxt{
                font-weight: bold;
                font-size: 14px;
                color: #5470C6;
                line-height: 1;
                text-align: left;
                position: absolute;
                top: -20px;
            }
            .banner{
                position: absolute;
                left: 0;
                top: 0;
                background: #5470C6;
            }
            .btmTxt{
                font-weight: 400;
                font-size: 14px;
                color: rgba(0,0,0,0.45);
                line-height: 1;
                text-align: left;
                position: absolute;
                top: 15px;
            }
        }
        .logo{
            max-width: calc(100% - 435px);
            max-height: 84px;
            width: calc(100% - 435px);
            display: flex;
            align-items: center;
            img{
                width: auto;
                height: 32px;
            }
        }
    }
}
</style>